import { FC, ReactNode } from 'react';
import { Container, Box } from '@mui/material';
import UserAdminGrid from 'src/components/userAdmin/userAdminGrid';

declare interface Props {
  children?: ReactNode;
}

const UserAdminContainer: FC<Props> = () => {
  return (
    <>
      <Box sx={{ mt: 6 }}>
        <Container maxWidth={'xl'}>
          <UserAdminGrid />
          <Box sx={{ mt: 2 }}>
            <b>Role Definitions:</b>
            <ul style={{ margin: '0px' }}>
              <li>Admin - Can edit users and edit Virtual Booths</li>
              <li>User - Can only edit virtual booths</li>
            </ul>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default UserAdminContainer;
